import { BufferGeometry, Line, LineBasicMaterial, Vector3 } from "three";
import { sphericalToCartesianThreeJs } from "../common/Coordinates";
export default class Route {
    mesh;
    sphericalCoordinates;
    maxR;
    minR;
    constructor(sphericalCoordinates, colour, minR, maxR) {
        this.maxR = maxR;
        this.minR = minR;
        this.sphericalCoordinates = sphericalCoordinates.filter((coord) => coord != undefined && coord.r != undefined && coord.theta != undefined && coord.phi != undefined);
        const material = new LineBasicMaterial({
            color: colour
        });
        const points = this.sphericalCoordinates
            .map(({ theta, phi }) => { return { r: this.maxR, theta, phi }; })
            .map((cooordinates) => sphericalToCartesianThreeJs(cooordinates))
            .map(({ x, y, z }) => new Vector3(x, y, z));
        const buffer = new BufferGeometry().setFromPoints(points);
        this.mesh = new Line(buffer, material);
    }
    update(λCamera) {
        const r = this.minR * (1 - λCamera) + this.maxR * λCamera;
        const points = this.sphericalCoordinates
            .map(({ theta, phi }) => { return { r, theta, phi }; })
            .map((coordinates) => sphericalToCartesianThreeJs(coordinates))
            .map(({ x, y, z }) => [x, y, z])
            .flat();
        const positions = this.mesh.geometry.attributes.position.array;
        for (let i = 0; i < positions.length; i++) {
            positions[i] = points[i];
        }
        this.mesh.geometry.attributes.position.needsUpdate = true;
    }
    dispose() {
        this.mesh.geometry.dispose();
        this.mesh.material.dispose();
    }
    getObject3D() {
        return this.mesh;
    }
}
